import { connect } from 'react-redux';
import { saveKey, saveProductId } from '../../../redux/actions/pagesActions';
import {
    setAccount,
    setAutoUpgrade,
    setCurrencyFromQuery,
    setDomainsFromQuery,
    setExtraFromQuery,
    setFeaturedFromQuery,
    setPeriodFromQuery,
    setRenew,
    setTariffFromQuery,
    setUiModeFromQuery,
} from '../../../redux/actions/cartAction';
import useQuery from '../../../hooks/useQuery';
import { FEATURED_PRODUCTS_PAIR } from '../../../constants/constants';
import convertToBoolean from '../../../lib/string/convertToBoolean';
import { productAvailableAccountsSelector } from '../../../redux/selectors/productSelector';
import { DEFAULT_PRODUCT_ID } from '../../../redux/constants/pagesConstants';

let initializationFlag = false;

function CTaskQueryParameter({
    saveKey,
    saveProductId,
    setPeriod,
    setTariff,
    setCurrency,
    setCartRenew,
    setFeatured,
    setExtra,
    setDomains,
    setAccount,
    setAutoUpgrade,
    accountsList,
    setUiMode,
}) {
    const query = useQuery();

    if (initializationFlag) {
        return null;
    }
    initializationFlag = true;

    const extraFlag = query.has('extra') ? convertToBoolean(query.get('extra')) : true;

    if (query.get('product_id')) {
        if (FEATURED_PRODUCTS_PAIR[query.get('product_id')]?.active) {
            saveProductId(query.get('product_id'));
            if (
                accountsList?.find((item) => +item.account_id === +query.get('account'))?.trial &&
                +query.get('product_id') === 7
            ) {
                setPeriod({
                    period: 'Month',
                    interval: '1',
                });
            } else {
                setPeriod({
                    period: FEATURED_PRODUCTS_PAIR[query.get('product_id')]?.defaults?.period,
                    interval:
                        FEATURED_PRODUCTS_PAIR[query.get('product_id')]?.defaults?.period_interval,
                });
            }
        } else {
            saveProductId(DEFAULT_PRODUCT_ID);
        }
    } else {
        saveProductId(DEFAULT_PRODUCT_ID);
    }
    if (query.get('user_token') || query.get('payment_page_token')) {
        saveKey(query.get('user_token'), query.get('payment_page_token'));
    }
    setExtra({ extra: extraFlag });
    if (query.get('tariff_id')) {
        setTariff({ tariff_id: query.get('tariff_id') });
    }
    if (query.get('featured')) {
        setFeatured({ featured: query.get('featured').split(',') });
    } else if (query.get('featured') === '') {
        setFeatured({ featured: [] });
    } else {
        setFeatured({ featured: '*' });
    }
    if (query.get('period') && query.get('period_interval')) {
        if (
            accountsList?.find((item) => +item.account_id === +query.get('account'))?.trial &&
            +query.get('product_id') === 7
        ) {
            setPeriod({
                period: 'Month',
                interval: '1',
            });
        } else {
            setPeriod({
                period: query.get('period'),
                interval: query.get('period_interval'),
            });
        }
    }
    if (query.get('currency')) {
        setCurrency({ currency: query.get('currency') });
    }

    if (query.get('ui_mode')) {
        setUiMode({ ui_mode: query.get('ui_mode') });
    }

    if (query.has('domains')) {
        setDomains({
            domains: query
                .get('domains')
                ?.split(',')
                .filter(Boolean)
                .map((domain) => Number(domain)),
        });
    }

    if (query.has('account_id')) {
        setAccount({ account: +query.get('account_id'), productId: +query.get('product_id') || 6 });
    }

    if (query.has('fua')) {
        setAutoUpgrade({ value: convertToBoolean(query.get('fua')) });
    }
    // Should be the last.
    if (query.has('renew')) {
        setCartRenew({ renew: convertToBoolean(query.get('renew')) });
    }

    return null;
}

const mapStateToProps = (state) => ({
    accountsList: productAvailableAccountsSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
    saveKey: (userToken, paymentPageToken) => dispatch(saveKey(userToken, paymentPageToken)),
    saveProductId: (data) => dispatch(saveProductId(data)),
    setPeriod: (data) => dispatch(setPeriodFromQuery(data)),
    setTariff: (data) => dispatch(setTariffFromQuery(data)),
    setExtra: (data) => dispatch(setExtraFromQuery(data)),
    setCurrency: (data) => dispatch(setCurrencyFromQuery(data)),
    setUiMode: (data) => dispatch(setUiModeFromQuery(data)),
    setDomains: (data) => dispatch(setDomainsFromQuery(data)),
    setCartRenew: (data) => dispatch(setRenew(data)),
    setFeatured: (data) => dispatch(setFeaturedFromQuery(data)),
    setAutoUpgrade: (data) => dispatch(setAutoUpgrade(data)),
    setAccount: (data) => dispatch(setAccount(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CTaskQueryParameter);
